import { Alert, Row } from "antd";
import { ReactNode, useCallback, useMemo } from "react";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import "./styles.scss";

type Props = {
  onClose: () => void;
  cookieName: string;
};

export const PortalNotification = ({ onClose, cookieName }: Props) => {
  const onClickLink = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault();

      Cookies.set(cookieName, "hide", {
        expires: 365,
        path: "/",
      });

      onClose();
    },
    [onClose, cookieName],
  );

  const description: ReactNode = useMemo(
    () => (
      <Row className="info-container">
        <Row className="icon-container justify-center mr-4">
          <ExclamationCircleOutlined className="text" />
        </Row>
        <Row className="notification-desc align-center justify-space-between">
          <Row className="d-block">
            <p className="my-0 text w-500">
              Starting in 2027, we will no longer send out payment coupons or
              1098s.
            </p>
            <p className="text-md desc-title">
              You can print them here at any time. If you are unable to print,
              contact our office.
            </p>
          </Row>
          <Link
            to="#"
            className="text-md w-500 ant-btn-link"
            onClick={onClickLink}
          >
            I Understand
          </Link>
        </Row>
      </Row>
    ),
    [onClickLink],
  );

  return (
    <Alert
      className="mt-4 pa-4 w-100 warn__container"
      description={description}
    />
  );
};
